import React from "react";

import Search from "../../assets/search.png";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 400px;
  text-align: center;
  padding-top: 40px;
`;

const SearchImg = styled.img`
  width: 80px;
  height: 80px;
`;
const Title = styled.h1`
  font-weight: 500;
  margin: 0;
  padding: 10px 0;
`;
const SubTitle = styled.p`
  font-weight: 500;
  font-size: 1em;
  color: gray;
  margin:0;
  padding: 0;
`;
const notFound = (props) => {
  return (
    <Container>
      <SearchImg src={Search} alt="search" />
      <Title>{props.title}</Title>
      <SubTitle>
        {props.subTitle}
      </SubTitle>
    </Container>
  );
};

export default notFound;
